import { styled, Dropdown, ComboImage, LazyImage, DropdownToggle, DropdownMenu } from '@teko/ui';
import React, { useState } from 'react';
import { getComboImageUrl, getComboName } from '../../helpers/index.es.js';
import { Gift } from '../Gift/Gift.es.js';
import { Variants } from '../Variants/Variants.es.js';
import { MobileLink } from '../../mobile/MobileLink/MobileLink.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const Wrapper = styled.div`
  display: flex;
`;
const ProductName = styled.p`
  padding: 0;
  margin: 0;
  font-size: 0.875rem;
  margin-bottom: 4px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
const Left = styled.div`
  display: flex;
  align-items: center;
`;
const Right = styled.div`
  flex: 1;
  margin-left: 1rem;
`;
const Action = styled.span(({ mgl = true }) => `
      font-size: 14px;
      color: #047fff;
      margin-left: ${mgl ? "1.5rem" : 0};
      cursor: pointer;
      display: inline-block;
      width: max-content;
      flex-shrink: 0;
    `);
const ComboList = styled.ul`
  padding: 0.25rem 0.75rem;
  list-style-type: none;
  border-radius: 0.5rem;
  box-shadow: 0 2px 0.5rem 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  background-color: white;
  margin: 0;
  width: max-content;
  max-width: 25rem;
`;
const StyledDropdown = styled(Dropdown)`
  width: max-content;
`;
const popperConfig = {
  modifiers: [
    {
      name: "offset",
      options: {
        offset: [0, 10]
      }
    }
  ]
};
const StyledGift = styled(Gift)`
  margin: 0.5rem 0;
`;
const SKU = styled.div`
  color: #848788;
  font-size: 0.875rem;
`;
const ProductInfo = ({
  product: {
    sku,
    imageUrl,
    name,
    variants = [],
    combos = [],
    link,
    childItems = []
  },
  className
}) => {
  const [comboOpen, setComboOpen] = useState(false);
  const isCombo = childItems.length > 0;
  const toggleCombo = () => {
    setComboOpen((prev) => !prev);
  };
  const image = isCombo ? /* @__PURE__ */ React.createElement(ComboImage, {
    images: getComboImageUrl(childItems)
  }) : /* @__PURE__ */ React.createElement(LazyImage, {
    height: 80,
    width: 80,
    contain: true,
    border: true,
    src: imageUrl,
    alt: "product"
  });
  const productName = isCombo ? getComboName(childItems) : name;
  return /* @__PURE__ */ React.createElement(Wrapper, {
    className
  }, /* @__PURE__ */ React.createElement(Left, null, image), /* @__PURE__ */ React.createElement(Right, null, /* @__PURE__ */ React.createElement(MobileLink, __spreadValues({}, link), /* @__PURE__ */ React.createElement("a", {
    target: "_blank",
    style: { color: "unset", textDecoration: "unset" }
  }, /* @__PURE__ */ React.createElement(ProductName, null, productName))), sku && /* @__PURE__ */ React.createElement(SKU, null, "SKU: ", sku), !!variants.length && /* @__PURE__ */ React.createElement(Variants, {
    variants
  }), !!combos.length && /* @__PURE__ */ React.createElement(StyledDropdown, {
    isOpen: comboOpen,
    toggle: toggleCombo,
    toggleType: "hover"
  }, /* @__PURE__ */ React.createElement(DropdownToggle, {
    toggleType: "hover"
  }, /* @__PURE__ */ React.createElement(Action, {
    mgl: false
  }, "Xem combo")), /* @__PURE__ */ React.createElement(DropdownMenu, {
    popperConfig,
    origin: "left top"
  }, /* @__PURE__ */ React.createElement(ComboList, null, combos.map(({ imageUrl: imageUrl2, name: name2 }, index) => /* @__PURE__ */ React.createElement(StyledGift, {
    key: index,
    image: {
      src: imageUrl2
    },
    text: name2
  })))))));
};

export { ProductInfo };
